<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BasePageTitle',
  mixins: [baseMixin],
  props: {
    title: {
      type: String,
      default: 'Page Title',
    },
    subtitle: {
      type: String,
      default: '',
    },
    subtitleOnTop: {
      type: Boolean,
      default: false,
    },
    backButton: {
      type: Boolean,
    },
  },
}
</script>

<template>
  <div
    :class="[isMobileViewPort ? 'mb-4' : 'mb-8', 'd-flex align-center mt-3']"
  >
    <slot name="leftAction"> </slot>
    <header class="d-flex justify-space-between">
      <div>
        <BasePageTitleSubtitle v-if="subtitleOnTop" id="page-subtitle">
          {{ subtitle }}
        </BasePageTitleSubtitle>
        <slot name="title">
          <BasePageTitleHeader id="page-title">
            {{ title }}
          </BasePageTitleHeader>
        </slot>
        <slot name="bottomSubtitle">
          <BasePageTitleSubtitle v-if="!subtitleOnTop" id="page-subtitle">
            {{ subtitle }}
          </BasePageTitleSubtitle>
        </slot>
      </div>
      <slot name="appendTitle"></slot>
    </header>
  </div>
</template>
